import { render, staticRenderFns } from "./PasswordHelperBlock.vue?vue&type=template&id=d5a47378&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormText} from 'bootstrap-vue'
    installComponents(component, {BFormText})
    

export default component.exports